module.exports = __webpack_public_path__ + "static/media/ntlm_schema.89b51f46.png";